<template>   
    <ul id="news-pagination" class="pagination">
        <router-link 
            v-for="(pageLink, index) in paginationObject"
            :key="index"  tag="li" 
            :to="{ path: `/news/${pageLink.target}` }" 
            class="nav-link"
            :class="[ activeClass(index,paginationObject.currentPage), noClickClass(pageLink.target) ]" 
            active-class="active">
            <a>{{ pageLink.content }}</a>
        </router-link>
    </ul>
</template>

<script>

export default {
    data(){
        return {
            // Structure for Information
            paginationObject: [{
                content: String,
                target: Number
            }],
            distance:3,
            totalPages: Number.parseInt(this.pagination.totalPages)
        }
    },
    props: ['pagination'],
    created(){
        this.fillPaginationObject();
    },
    watch: {
        pagination: ()=>{
            this.fillPaginationObject();
        }
    },
    computed:{
    },
    methods:{
        noClickClass:  (mytarget)=>{
            return  (mytarget ==='#') ? 'noclick' : "";
        },
        activeClass: (index,cp)=>{
            return (index===cp) ? 'active' : "";
        },
        doPageLinks: (distance, totalPages, currentPage)=> {
            let onlyOnce = true;
            let myPaginationObject = [];
            const addLink = (content, i) => {
              myPaginationObject.push({
                content: content,
                target: i,
              });
            }
            for (let i = 1; i <= totalPages; i++) {
                if (i <= distance) {
                    if (i === 1) {
                        addLink("«", i);
                    }
                    addLink(i, i);
                }
                if (totalPages > distance * 2) {
                    // Everything "Inner"
                    if (i > distance && (i <= totalPages - distance)) {
                        if (i === currentPage - 1) {
                            addLink("…", "#");
                            onlyOnce = false;
                        }
                        if (i >= currentPage - 1 && i <= currentPage + 1) {
                            addLink(i, i);
                        }
                        if (i === currentPage + 1) {
                            addLink("…", "#");
                            onlyOnce = false;
                        }
                    } else {
                        if (i >= distance && currentPage < distance) {
                            if (onlyOnce) {
                                addLink("…", "#");
                                onlyOnce = false;
                            }
                        }
                        if ((currentPage >= totalPages - distance) && i > (totalPages - distance)) {
                            if (onlyOnce) {
                                addLink("…", "#");
                                onlyOnce = false;
                            }
                        }
                    }
                }
                // Everything attached to Minimum
                if (i > totalPages - distance && i > distance) {
                    addLink(i, i);
                    if (i === totalPages) {
                        addLink("»", i);
                    }
                }
            }
            return myPaginationObject;
        },
        fillPaginationObject : function (){
            // Uses Mixin to Create Pagination
            this.paginationObject = this.doPageLinks(this.distance,this.totalPages,this.pagination.currentPage);
        }
    }
}
</script>
<style lang="scss" scoped>
ul {
    .active {
        border: 1px dotted #F0C854;
        a {color:#F0C854;}
    }

    li {
        display: inline-block;
        padding: 0 .5em;
        &:first-child{
            &.active {
                border:none;
                a{color:inherit;}
            }
        }
    }
    padding-bottom: 4em;
    .noclick{
        pointer-events: none;
    }
}
</style>